import type { Persistor } from "redux-persist";

// redux-persist v6 never flushes throttled writes on unload on its own; this is best-effort since the IndexedDB write it triggers is async.
const installPersistorHideFlush = (persistor: Persistor, onBeforeFlush?: () => void) => {
	const handlePagehide = () => {
		onBeforeFlush?.();
		void persistor.flush();
	};
	const handleVisibilityChange = () => {
		if (document.visibilityState === "hidden") {
			onBeforeFlush?.();
			void persistor.flush();
		}
	};

	window.addEventListener("pagehide", handlePagehide);
	document.addEventListener("visibilitychange", handleVisibilityChange);

	return () => {
		window.removeEventListener("pagehide", handlePagehide);
		document.removeEventListener("visibilitychange", handleVisibilityChange);
	};
};

export default installPersistorHideFlush;
